module.exports = __webpack_public_path__ + "img/avbi02b.6148ffe3.png";